import { render } from "./CancerTreatmentPatternPrescribedDrugs.vue?vue&type=template&id=2e8612aa"
import script from "./CancerTreatmentPatternPrescribedDrugs.vue?vue&type=script&lang=js"
export * from "./CancerTreatmentPatternPrescribedDrugs.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__